import HistoryRow from 'components/HistoryBatch/HistoryRow';
import Loader from 'components/Loader';
import { useHistoryBatch } from 'contexts/HistoryBatch';
import React from 'react';
import { useTranslation } from 'react-i18next';
import HistoryBatchTableHeader from '../HistoryBatchTableHeader';

export const HistoryBatchList = () => {
  const { t } = useTranslation(['history', 'beneficiaries']);

  const { batchFiles, loading, showMore, isLastPage } = useHistoryBatch();

  const hasUperThanTenItems = batchFiles?.length >= 10;

  const isVisibleButtonShowMore = hasUperThanTenItems && !isLastPage;

  return (
    <>
      <div className="beneficiaries-table-wrapper">
        <div className="mt-2">{loading && <Loader />}</div>
        <div className="container-table-beneficiaries history-page">
          <table>
            <tbody>
              <HistoryBatchTableHeader />
              <HistoryRow />
            </tbody>
          </table>
        </div>
      </div>
      {isVisibleButtonShowMore && (
        <div className="button-wrapper">
          <button className="show-more-button" type="button" onClick={showMore}>
            {loading ? (
              <Loader small />
            ) : (
              <>
                {t('beneficiaries:show_more')}
                <span className="chevron" />
              </>
            )}
          </button>
        </div>
      )}
    </>
  );
};
